import type { InputHTMLAttributes } from 'react';

import { cn } from '@/lib/cn';

import { controlBase } from './controlStyles';

type Props = InputHTMLAttributes<HTMLInputElement>;

/** A text input with the §4 chrome. Pair it with `Field` for its label and error. */
export function Input({ className, ...props }: Props) {
  return <input className={cn(controlBase, 'w-full', className)} {...props} />;
}
